var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Payments = YouLi.Trip.Payments ? YouLi.Trip.Payments : {};

(function (YouLi) {
    (function (Trip) {
        (function (Payments) {

            YouLi.Trip.Payments.ConnectedPaymentGateway = YouLi.Common.PaymentGateway.Stripe;
            YouLi.Trip.Payments.StripeHandler = undefined;
            YouLi.Trip.Payments.AuthorizeNetClientKey = "";
            YouLi.Trip.Payments.AuthorizeNetAPIKey = "";
            YouLi.Trip.Payments.ThirdPartyCardSurchargePercent = 0;
            YouLi.Trip.Payments.RefundProtectPercent = 0;
            YouLi.Trip.Payments.RefundProtectOptedOutConfirmed = false;
            YouLi.Trip.Payments.CurrencyHasDecimals = true;
            YouLi.Trip.Payments.SaveCardMethodType = "";

            YouLi.Trip.Payments.CostPrepayTotalForAllGangMembers = 0;

            YouLi.Trip.Payments.InviteeHasPayments = false;
            YouLi.Trip.Payments.InviteeReferenceCode = "";

            YouLi.Trip.Payments.ChipAwayMinimumAmount = 0;
            YouLi.Trip.Payments.ChipAwayMaximumAmount = 0;

            YouLi.Trip.Payments.PayNowButtonText = "Pay Now";
            YouLi.Trip.Payments.NotifyPlannerButtonText = "Notify Planner";
            YouLi.Trip.Payments.PackageSoldOutFooterWarningText = "Choose Another Package";

            YouLi.Trip.Payments.InviteeHasOwing = false;

            YouLi.Trip.Payments.HasAnyOwingInstallments = false;
            YouLi.Trip.Payments.SelectedInstallmentId = "";
            YouLi.Trip.Payments.InstallmentIdBalance = undefined;
            YouLi.Trip.Payments.InstallmentIdOther = undefined;

            YouLi.Trip.Payments.RecentlyClickedEnrolAutoPay = undefined;

            YouLi.Trip.Payments.BillToEmail = undefined;

            YouLi.Trip.Payments.GetRefundProtectSelection = function () {
                if ($('input[type=radio][name="CurrentInvitee.RefundProtectSelection"]').length > 0) {
                    return $('input[type=radio][name="CurrentInvitee.RefundProtectSelection"]:checked').val();
                }
                else {
                    return $('input[name="CurrentInvitee.RefundProtectSelection"]').val();
                }
            }

            YouLi.Trip.Payments.SendPaymentDataToAuthorizeNet = function (event) {

                // Validate the form before anything else
                var $form = $('#GenericPaymentForm');
                $form.validateBootstrap();
                if (!$form.valid()) {
                    YouLi.Common.UI.ScrollToTopModal("GenericPaymentFormDialog");
                    return;
                }

                var authData = {};
                authData.clientKey = YouLi.Trip.Payments.AuthorizeNetClientKey;
                authData.apiLoginID = YouLi.Trip.Payments.AuthorizeNetAPIKey;

                var cardData = {};
                cardData.cardNumber = document.getElementById("p-card-number").value;
                cardData.month = document.getElementById("p-exp-Month").value;
                cardData.year = document.getElementById("p-exp-Year").value;
                cardData.cardCode = document.getElementById("p-card-Code").value;;

                var secureData = {};
                secureData.authData = authData;
                secureData.cardData = cardData;

                Accept.dispatchData(secureData, responseHandler);

                function responseHandler(response) {
                    if (response.messages.resultCode === "Error") {
                        var i = 0;
                        while (i < response.messages.message.length) {
                            console.log(
                                response.messages.message[i].code + ": " +
                                response.messages.message[i].text
                            );
                            $("#GenericPaymentErrorMessage").text(response.messages.message[i].code + ": " +
                                response.messages.message[i].text).removeClass("hidden");
                            i = i + 1;
                        }
                    }
                    else {
                        $("#GenericPaymentErrorMessage").addClass("hidden");
                        document.getElementById("dataDescriptor").value = response.opaqueData.dataDescriptor;
                        document.getElementById("dataValue").value = response.opaqueData.dataValue;
                        // If using your own form to collect the sensitive data from the customer,
                        // blank out the fields before submitting them to your server.
                        document.getElementById("p-card-number").value = "";
                        document.getElementById("p-exp-Month").value = "";
                        document.getElementById("p-exp-Year").value = "";
                        document.getElementById("p-card-Code").value = "";
                        var FirstName = document.getElementById("p-billto-first-name").value;
                        var LastName = document.getElementById("p-billto-last-name").value;
                        var Address = document.getElementById("p-billto-street-line1").value + " " + document.getElementById("p-billto-street-line2").value;
                        var city = document.getElementById("p-billto-city").value;
                        var zip = document.getElementById("p-postal-code").value;

                        YouLi.Trip.Payments.ProcessGenericCreditCardPayment(response.opaqueData.dataValue, "authorizenet");
                    }
                }
            };

            YouLi.Trip.Payments.CheckForPaymentButtonUpdate = function () {

                // If we have a selected payment method, update the footer to have the payment button (in case it's not already set)
                if ($("input[type=radio][name=PaymentMethod]:checked").val()) {
                    SetFooterToPaymentButton($("input[type=radio][name=PaymentMethod]:checked").val());
                }
            };

            YouLi.Trip.Payments.InitialiseResponseChecks = function () {
                $(".content-trip-paymentdetails-itinerary-addons .multistate-check-schedule-item-response").multiStateCheck({
                    states: ["unchecked", "checked"],
                    onAfterChangeState: function (e) {

                        YouLi.Common.UI.ShowLoading();

                        const applyToGang = false;
                        YouLi.Trip.Schedule.Response.MultiStateCheckUpdateAndTakeAction(e.target, applyToGang, function () {
                            YouLi.Common.UI.HideLoading();
                        }, true);
                    }
                }).each(function () {
                    if ($("#PreviewMode").val() == "True") {
                        $(this).attr("disabled", "");
                    }
                });
            };


            /* Returns a promise */
            YouLi.Trip.Payments.CheckForOverpayment = function () {

                YouLi.Common.UI.ShowLoading();

                let data = {
                    couponCode: $("#ChargeCouponCode").val(),
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    chargeAmount: $("#ChargeAmount").val(),
                    surchargeAmount: $("#SurchargeAmount").val(),
                    refundProtectAmount: $("#RefundProtectAmount").val()
                };

                return new Promise((resolve, reject) => {
                    $.ajax({
                        url: '/trip/checkpaymentforoverpayment',
                        type: 'POST',
                        cache: false,
                        dataType: "json",
                        data: JSON.stringify(data),
                        contentType: "application/json; charset=utf-8",
                        complete: function (response) {
                            YouLi.Common.UI.HideLoading();
                            var errorDate;
                            if (response.responseJSON != undefined && response.responseJSON.url) {
                                window.open(response.responseJSON.url, '_blank');
                            }
                            else if (response.status === 500) {
                                $(".content-trip-paymentdetails-error").removeClass("hidden");

                                errorDate = moment();
                                $("#PaymentErrorDate").text(errorDate.format("D MMM YYYY") + " @ " + errorDate.format("h:mma"));
                                $("#PaymentErrorMessage").text("");
                            }
                            else if (response.responseJSON.errorMessage) {
                                $(".content-trip-paymentdetails-error").removeClass("hidden");

                                errorDate = moment(response.responseJSON.paymentErrorDate);

                                $("#PaymentErrorDate").text(errorDate.format("D MMM YYYY") + " @ " + errorDate.format("h:mma"));
                                $("#PaymentErrorMessage").text(response.responseJSON.errorMessage);
                            }
                            else if (response.responseJSON.cookieError && response.responseJSON.message) {
                                YouLi.Common.UI.ShowStaticStandardDialogNoClose(response.responseJSON.message, "Identity error");
                            }
                            else {
                                resolve();
                            }
                        }
                    });
                });

            };

            YouLi.Trip.Payments.processPaymentWithSavedPaymentMethod = function (isThirdPartyCard) {

                let newPaymentId, couponPaymentId;
                var redirectURL = window.location.href;

                if (YouLi.Trip.Payments.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.Stripe) {
                    const savedPaymentMethodId = isThirdPartyCard ? $("#ThirdPartyCardPaymentMethodId").val() : $("#SavedPaymentMethodId").val();

                    YouLi.Trip.Payments.CheckForOverpayment()
                        .then(() => {
                            YouLi.Common.UI.ShowLoading();
                        })
                        .then(() => YouLi.Trip.Payments.ProcessStripePayment(undefined, "stripe", savedPaymentMethodId))
                        .then((data) => {

                            newPaymentId = data.newPaymentId;
                            couponPaymentId = data.couponPaymentId;

                            if (data.redirectURL) {
                                redirectURL = data.redirectURL;
                            }

                            // 3. Create and Confirm Payment Intent to charge immediately

                            // First, ensure it's actually got a paymentId
                            if (!newPaymentId) {
                                var userMessage = "An error occurred with the payment charge - invalid payment Id";
                                var debugMessage = "Credit Card failure: passed a " + (newPaymentId == null ? "null" : "empty string") + " for paymentId on trip "
                                    + $("#TripId").val() + " for invitee " + $("#InviteeId").val() + " is failing. Domain: " + window.location.host
                                var subject = "Exception occurring - internalPaymentId is being set to an invalid value in Stripe Payment Intent";

                                YouLi.Common.OpenSupportTicket(userMessage, debugMessage, subject);

                                throw new Error(userMessage);
                            }

                            const isEnrolInAutoPayChecked = !isThirdPartyCard && $("#SavedPaymentMethodConfirmationDialog #EnrolInAutoPay").is(":checked");

                            return YouLi.Trip.Payments.ChargeStripeSavedPaymentMethod(newPaymentId, redirectURL, isThirdPartyCard, savedPaymentMethodId, isEnrolInAutoPayChecked);
                        })
                        .then((data) => {

                            if (data.redirectURL) {
                                redirectURL = data.redirectURL; // update from the payment intent
                            }

                            if (window.location.href == redirectURL)
                                window.location.reload();
                            else
                                window.location.href = redirectURL;

                        })
                        .catch((errorObject) => {
                            console.error('Error:', errorObject.message);

                            // roll back the payment (and any created coupon payment) that was created locally if a payment was created
                            var paymentsToDelete = [];
                            if (newPaymentId)
                                paymentsToDelete.push(newPaymentId);
                            if (couponPaymentId)
                                paymentsToDelete.push(couponPaymentId);
                            YouLi.CreditCardPaymentForm.CancelInProgressPayment(paymentsToDelete);

                            YouLi.Common.UI.HideLoading();

                            if (!errorObject.errorHandled) {
                                YouLi.CreditCardPaymentForm.OnPageErrorHandlerFunction(errorObject.message, moment());
                            }

                        });
                }
                else if (YouLi.Trip.Payments.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.PayPal) {

                    const savedPaymentMethodId = $("#SavedPaymentMethodId").val();      // Nb: no handling third party cards for now

                    YouLi.Trip.Payments.CheckForOverpayment()
                        .then(() => {
                            YouLi.Common.UI.ShowLoading();
                        })
                        .then(() => processPayment("paypal", savedPaymentMethodId))
                        .then((response) => {
                            YouLi.Common.UI.HideLoading();
                        })
                        .catch((errorObject) => {
                            console.error('Error:', errorObject.message);

                            // roll back the payment (and any created coupon payment) that was created locally if a payment was created
                            var paymentsToDelete = [];
                            if (newPaymentId)
                                paymentsToDelete.push(newPaymentId);
                            if (couponPaymentId)
                                paymentsToDelete.push(couponPaymentId);
                            YouLi.CreditCardPaymentForm.CancelInProgressPayment(paymentsToDelete);

                            YouLi.Common.UI.HideLoading();

                            if (!errorObject.errorHandled) {
                                YouLi.CreditCardPaymentForm.OnPageErrorHandlerFunction(errorObject.message, moment());
                            }

                        });
                }
                else {
                    console.log("Invalid gateway for saved payment method");
                }

            }

            YouLi.Trip.Payments.ChargeStripeSavedPaymentMethod = function (paymentId, redirectURL, isThirdPartyCard, savedPaymentMethodId, isEnrolInAutoPayChecked) {

                let data = {
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    inviteeReferenceCode: YouLi.Trip.Payments.InviteeReferenceCode,
                    chargeAmount: $("#ChargeAmount").val(),
                    chargeLabel: $("#ChargeLabel").val(),
                    paymentId: paymentId,
                    isRegisteredWithPayment: false, // never true for Trip Page, only for Checkout
                    useThirdPartyCardPaymentMethod: isThirdPartyCard,
                    thirdPartyCardPaymentCostCentre: $("#ThirdPartyCardPaymentCostCentre").val(),
                    thirdPartyCardPaymentDepartment: $("#ThirdPartyCardPaymentDepartment").val(),
                    thirdPartyCardPaymentApprovedBy: $("#ThirdPartyCardPaymentApprovedBy").val(),
                    savedPaymentMethodId: savedPaymentMethodId,
                    isAutoPayEnrol: isEnrolInAutoPayChecked,
                    returnURL: redirectURL
                };

                return fetch("/trip/chargestripesavedpaymentmethod", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(data),
                }).then(response => {
                    if (!response.ok) {
                        throw new Error("An error occurred when updating payment intent");
                    }
                    return response.json();
                }).then(data => {

                    if (!data.success) {
                        throw {
                            message: "An error occurred when charging payment",
                            errorHandled: true
                        };
                    }

                    var redirectURL = data.redirectURL;
                    return Promise.resolve({ redirectURL });

                }).catch((error) => {

                    // B. Thulke: I had added this during original dev, but don't see why we would want to do this.  We want them to try again.
                    // if we have an issue with updating the intent, destroy the credit card form
                    //YouLi.CreditCardPaymentForm.StripePaymentElement.destroy();
                    YouLi.Trip.Payments.ShowErrorOnPage("Error processing payment.  Please try again or contact your planner for assistance", moment());

                    throw {
                        message: "Error charging payment",
                        errorHandled: true
                    };
                });
            }

            YouLi.Trip.Payments.RefreshPaymentMethod = function (preventScroll = false) {
                ChangeMethod($("input[type=radio][name=PaymentMethod]:checked").val(), preventScroll);
                ClearFooterPaymentButton();
                ForceFooterUpdate();
            }

            YouLi.Trip.Payments.UpdateGangPlaceholdersFormSuccess = function (result) {

                var formSubmitBtn = $("form").find("input[type='submit']");

                if (result.errors) {
                    YouLi.Common.UI.HideInputLoading(formSubmitBtn);
                    YouLi.Common.UI.HideLoading();
                    YouLi.Common.UI.ClearClientSideErrors();
                    YouLi.Common.UI.FormatClientSideErrors(result.errors);

                } else {
                    YouLi.Common.UI.ClearClientSideErrors();

                    // Update the payment details UI now their name etc has changed
                    if (result.showCosts) {
                        $(".content-tab-paymentdetails").removeClass("hidden");
                    }

                    RefreshInviteesTab(result.inviteesDetailsHtmlString, result.showInvitees);

                    var initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]:checked").val();
                    if ($(".content-trip-paymentdetails-costs").length > 0)
                        $(".content-trip-paymentdetails-costs").html(result.paymentDetailsHtml);

                    YouLi.Trip.Payments.InitialiseUI();
                    YouLi.Common.UI.Init();

                    // reinitialise
                    $("input[type=radio][name=PaymentMethod][value=" + initialSelectedPaymentMethod + "]").attr("checked", true);
                    ChangeMethod(initialSelectedPaymentMethod, true);

                    $('#GangPlaceholdersDialog').modal('hide');
                }
            };

            YouLi.Trip.Payments.UpdateGangPlaceholdersFormFailure = function (xhr, status, error) {
                var formSubmitBtn = $("form").find("input[type='submit']");
                YouLi.Common.UI.HideInputLoading(formSubmitBtn);

                YouLi.Common.UI.FormatClientSideErrors(error, xhr);

                $('#GangPlaceholdersDialog').animate({ scrollTop: 0 }, 800);
            };

            var hasBillingAddress = function () {
                return $("#BillToFieldsIncluded") && $("#BillToFieldsIncluded").val() == "true";
            }

            /* Returns a promise */
            var processPayment = function (paymentMethod, savedPaymentMethodId) {

                var dataString = new FormData($("#PaymentChargeForm")[0]);

                $(".content-trip-paymentdetails-error").addClass("hidden");
                $(".paypal-trip-paymentdetails-error").addClass("hidden");
                YouLi.Common.UI.ShowLoading();

                dataString.append("paymentMethod", paymentMethod);

                const isChipAwaySelected = $("input[type=radio][name=PaymentOption]:checked").val() == "chipaway";
                dataString.append("isChipAway", isChipAwaySelected);

                dataString.append("isRegisteredWithPayment", false);// never true for Trip Page, only for Checkout

                if (YouLi.Trip.Payments.RefundProtectOptedOutConfirmed)
                    dataString.append("optedOutRefundProtect", true);

                dataString.append("RefundProtectSelection", YouLi.Trip.Payments.GetRefundProtectSelection());

                dataString.append("includedBillingAddress", hasBillingAddress());
                if (hasBillingAddress()) {
                    // add credit card form details like billing details
                    var creditCardFormData = new FormData($('#GenericPaymentForm')[0]);
                    for (let pair of creditCardFormData.entries()) {
                        dataString.append(pair[0], pair[1]);
                    }
                }

                if ($('input[type=radio][name=PaymentMethod]:checked').val() === "thirdpartycard") {
                    data["IsThirdPartyCardPayment"] = true;
                    data["ThirdPartyCardPaymentCostCentre"] = $("#ThirdPartyCardPaymentCostCentre").val();
                    data["ThirdPartyCardPaymentDepartment"] = $("#ThirdPartyCardPaymentDepartment").val();
                    data["ThirdPartyCardPaymentApprovedBy"] = $("#ThirdPartyCardPaymentApprovedBy").val();
                }

                if (savedPaymentMethodId) {
                    dataString.append("SavedPaymentMethodId", savedPaymentMethodId);
                }

                return new Promise((resolve, reject) => {
                    $.ajax({
                        url: '/trip/inviteemakepayment',
                        type: 'POST',
                        data: dataString,
                        cache: false,
                        contentType: false,
                        processData: false,
                        complete: function (response) {
                            YouLi.Common.UI.HideLoading();

                            if ($("#GenericPaymentFormDialog").hasClass("in")) {
                                YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                                $("#GenericPaymentFormDialog").modal("hide");
                            }

                            if (response.status === 500) {
                                YouLi.Trip.Payments.ShowErrorOnPage("", moment());

                                YouLi.Trip.Payments.RefreshPaymentMethod(true);
                            }
                            else if (response.responseJSON.statusCode === 500) {
                                YouLi.Trip.Payments.ShowErrorOnPage(response.responseJSON.paymentErrorMessage, moment(response.responseJSON.paymentErrorDate), paymentMethod);

                                YouLi.Trip.Payments.RefreshPaymentMethod(true);
                            }
                            else if (response.responseJSON.cookieError && response.responseJSON.message) {
                                YouLi.Common.UI.ShowStaticStandardDialogNoClose(response.responseJSON.message, "Identity error");
                            }
                            else {

                                if ($("#IsBooked").val() != "True") {
                                    if (YouLi.Common.GetGAData != null) {
                                        var gaData = YouLi.Common.GetGAData("purchase");
                                        dataLayer.push({ ecommerce: null });
                                        dataLayer.push(gaData);
                                    }
                                }

                                // Note: even for payment methods that redirect the user (e.g PayPal or Custom links), we still refresh in the background, so that if they hit "back" it will have refreshed info
                                // B. Thulke: note that currently this is NOT actually staying applied when the user hits "Back" in their
                                // browser to return to the trip page. See https://stackoverflow.com/questions/10096671/chrome-back-button-only-giving-cached-version-of-initial-page-without-any-ajax for a
                                // possible solution, setting the cache-control header for the original trip page index request.
                                $('#payment-detail-content').html(response.responseJSON.paymentDetailsHtmlString);
                                $("#content-trip-paymentdetails").removeClass("hidden");
                                YouLi.Trip.Payments.InitialiseUI();
                                YouLi.Common.UI.Init();     // reinitialise things like popovers!
                                $('.trip-heading-title').html(response.responseJSON.tripHeadingTitle);
                                $('.content-trip-heading-details.content-trip-heading-details-bullets').html(response.responseJSON.tripHeadingDetails);
                                RefreshInviteesTab(response.responseJSON.inviteesDetailsHtmlString, response.responseJSON.showInvitees);
                                $('#tasks-content').html(response.responseJSON.tasksListHtmlString);
                                YouLi.Trip.ShowInviteesAllTab = response.responseJSON.showInviteesAllTab;

                                $('html, body').animate({
                                    scrollTop: $(".cost-payments").offset().top - 80
                                }, 1000, () => {
                                    if (response.responseJSON.placeholdersDetails) {
                                        $('#GangPlaceholdersDialogContent').html(response.responseJSON.placeholdersDetails);
                                        $('#GangPlaceholdersDialog').modal('show');
                                    }
                                });

                                dataLayer.push({
                                    'tripName': $("#TripName").val(),
                                    'totalPrice': YouLi.Trip.Payments.CostPrepayTotalForAllGangMembers,
                                    'paymentAmount': YouLi.PaymentChargeForm.GetChargeAmount(),
                                    'event': 'Trip Booked'
                                });

                                //google tag manager
                                $('#GoogleAnalyticsData').html(response.responseJSON.googleAnalyticsHtml);

                                YouLi.Trip.SetupUpdatePaymentsListTimer();

                                YouLi.Trip.Payments.RefreshPaymentMethod();

                                // Redirect if specified - for phone we only redirect on mobile
                                if (response.responseJSON.redirectURL && (paymentMethod != "phone" || YouLi.Common.Utils.IsMobile())) {
                                    window.location.href = response.responseJSON.redirectURL;
                                }
                            }

                            resolve(response);
                        }
                    });
                });
            };

            YouLi.Trip.Payments.ShowErrorOnPage = function (errorMessage, errorDate /* a Moment date */, paymentMethod) {

                if (errorDate)
                    $("#PaymentErrorDate").text(errorDate.format("D MMM YYYY") + " @ " + errorDate.format("h:mma"));

                $(".payment-error-message").text(errorMessage);

                if ($("#GenericPaymentFormDialog").hasClass("in")) {
                    YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                    $("#GenericPaymentFormDialog").modal("hide");
                }

                if (paymentMethod === 'paypal') {
                    $('.paypal-trip-paymentdetails-error').removeClass('hidden');
                    $('html, body').animate({
                        scrollTop: $('.paypal-trip-paymentdetails-error').offset().top - 80
                    }, 1000);

                } else {
                    $('.content-trip-paymentdetails-error').removeClass('hidden');
                    $('html, body').animate({
                        scrollTop: $('.content-trip-paymentdetails-error').offset().top - 80
                    }, 1000);

                }
            };

            YouLi.Trip.Payments.ProcessGenericCreditCardPayment = function (nonce, paymentMethod) {

                if (nonce) {
                    var $form = $('#PaymentChargeForm');

                    $("#chargeNonce").remove();
                    $form.append($('<input type="hidden" id="chargeNonce" name="chargeNonce">').val(nonce));
                }

                return processPayment(paymentMethod); // TODO: Base this on the planner's settings
            };

            /* Returns a promise */
            YouLi.Trip.Payments.ProcessStripePayment = function (paymentIntentId, paymentMethod, savedPaymentMethodId) {

                var dataString = new FormData($("#PaymentChargeForm")[0]);

                dataString.append("paymentMethod", "stripe");

                const pmType = YouLi.CreditCardPaymentForm.SelectedPaymentMethodType;
                if (pmType) {
                    dataString.append("paymentMethodType", pmType);
                }

                if (savedPaymentMethodId) {
                    dataString.append("savedPaymentMethodId", savedPaymentMethodId);
                }

                // Enrol in AutoPay can be done either using Saved PM dialog or Card Dialog
                // If checkbox is checked in one of the dialog, treat as intention to enrol
                const isInSavedDialog = $("#SavedPaymentMethodConfirmationDialog #EnrolInAutoPay").is(":checked");
                const isInGenericDialog = $("#GenericPaymentFormDialog #EnrolInAutoPay").is(":checked");
                const isIntentionToEnrolInAutoPay = isInSavedDialog || isInGenericDialog;
                if (isIntentionToEnrolInAutoPay) {
                    dataString.append("IsIntentionToEnrolInAutoPay", true);
                }

                if (paymentIntentId) {
                    var $form = $('#PaymentChargeForm');

                    $("#chargeNonce").remove();
                    $form.append($('<input type="hidden" id="chargeNonce" name="chargeNonce">').val(paymentIntentId));
                }

                const isChipAwaySelected = $("input[type=radio][name=PaymentOption]:checked").val() == "chipaway";
                dataString.append("isChipAway", isChipAwaySelected);

                dataString.append("isRegisteredWithPayment", false);// never true for Trip Page, only for Checkout

                if (YouLi.Trip.Payments.RefundProtectOptedOutConfirmed)
                    dataString.append("optedOutRefundProtect", true);

                dataString.append("RefundProtectSelection", YouLi.Trip.Payments.GetRefundProtectSelection());

                dataString.append("includedBillingAddress", hasBillingAddress());
                if (hasBillingAddress()) {
                    // add credit card form details like billing details
                    var creditCardFormData = new FormData($('#GenericPaymentForm')[0]);
                    for (let pair of creditCardFormData.entries()) {
                        dataString.append(pair[0], pair[1]);
                    }
                }

                if ($('input[type=radio][name=PaymentMethod]:checked').val() === "thirdpartycard") {
                    dataString.append("IsThirdPartyCardPayment", true);
                    dataString.append("ThirdPartyCardPaymentCostCentre", $("#ThirdPartyCardPaymentCostCentre").val());
                    dataString.append("ThirdPartyCardPaymentDepartment", $("#ThirdPartyCardPaymentDepartment").val());
                    dataString.append("ThirdPartyCardPaymentApprovedBy", $("#ThirdPartyCardPaymentApprovedBy").val());
                }

                return fetch("/trip/inviteemakepayment", {
                    method: "POST",
                    headers: {
                        'Cache-Control': 'no-cache'
                    },
                    body: dataString
                }).then(response => {

                    if (!response.ok) {
                        throw new Error(response.message);
                    }

                    return response.json();
                }).then(data => {
                    if (data.statusCode == 500) {

                        YouLi.Trip.Payments.ShowErrorOnPage(data.paymentErrorMessage, moment(data.paymentErrorDate));

                        YouLi.Trip.Payments.RefreshPaymentMethod(true);

                        throw {
                            message: "Failed to create payment: " + data.paymentErrorMessage,
                            errorHandled: true
                        };
                    }
                    else if (data.cookieError && data.message) {
                        $("#GenericPaymentFormDialog").modal("hide");

                        YouLi.Common.UI.ShowStaticStandardDialogNoClose(data.message, "Identity error");

                        throw {
                            message: data.message,
                            errorHandled: true
                        };
                    }


                    //google tag manager 
                    if ($("#IsBooked").val() != "True") {
                        if (YouLi.Common.GetGAData != null) {
                            var gaData = YouLi.Common.GetGAData("purchase");
                            dataLayer.push({ ecommerce: null });
                            dataLayer.push(gaData);
                        }
                    }
                    $('#GoogleAnalyticsData').html(data.googleAnalyticsHtml);

                    var newPaymentId = data.newPaymentId;
                    var couponPaymentId = data.couponPaymentId;
                    var redirectURL = data.redirectURL;
                    return Promise.resolve({ newPaymentId, couponPaymentId, redirectURL });
                });
            };

            var ForceFooterUpdate = function () {
                YouLi.Trip.FooterUpdatesPaused = false;
                YouLi.Trip.UpdateResponseFooter(runOnce = true, checkTripUpdates = false);
            };

            var SetFooterToPaymentButton = function (selectedMethod) {

                // update footer for payment button
                if (selectedMethod) {
                    YouLi.Trip.FooterUpdatesPaused = true;
                    var footerForPayment = "";
                    let isPackageSoldout = $(".pay-now-button-label").data('sold-out');
                    let isFull = $(".pay-now-button-label").data('already-full');
                    let wouldOverbook = $(".pay-now-button-label").data('would-overbook');

                    if (isFull) {
                        footerForPayment = `<p class='footer-payment-label'>Sorry, this trip is now SOLD OUT.</p>`;
                    } else if (wouldOverbook) {
                        footerForPayment = `<p class='footer-payment-label'>Sorry, too many people, select a lower occupancy or another package.</p>`;
                    }
                    else if (isPackageSoldout) {
                        footerForPayment = `<p class='footer-payment-label'>${YouLi.Trip.Payments.PackageSoldOutFooterWarningText}</p>`;
                    } else {
                        footerForPayment = $("<p class='footer-payment-label'>Amount to be paid now </p>")
                            .append(`<span class='cost-line-item-amount-payment-total'>${YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount())}</span>`);
                    }
                    $(".content-trip-response-footer")
                        .removeClass("hidden")
                        .html(footerForPayment);

                    $(".content-trip-response-footer").append($(".payment-button").clone());
                }
            };

            var ClearFooterPaymentButton = function () {
                $(".content-trip-response-footer").html("");
            }

            var ChangePaymentOption = function (selectedOption) {

                $(".installments-details").addClass("hidden");

                if (!YouLi.Trip.Payments.InviteeHasPayments && selectedOption == "installment") {
                    $(".installments-details").removeClass("hidden");
                }

                YouLi.CreditCardPaymentForm.UpdateAutoPayVisibility(selectedOption != "balance");

                $(".cost-line-item-payment-total").toggleClass("hidden", !selectedOption); // only show if a method is selected

                $("#ChipAwayPaymentOptionDetails").toggleClass("hidden", selectedOption != "chipaway");

                // Reset teh selected installment value
                if (selectedOption == "installment")
                    YouLi.Trip.Payments.SelectedInstallmentId = YouLi.Trip.Payments.InstallmentIdOther;
                else if (selectedOption == "chipaway") {
                    // "chip away" at the next installment or the balance if there's no installments owed
                    if (YouLi.Trip.Payments.HasAnyOwingInstallments)
                        YouLi.Trip.Payments.SelectedInstallmentId = YouLi.Trip.Payments.InstallmentIdOther;
                    else
                        YouLi.Trip.Payments.SelectedInstallmentId = YouLi.Trip.Payments.InstallmentIdBalance;
                }
                else
                    YouLi.Trip.Payments.SelectedInstallmentId = YouLi.Trip.Payments.InstallmentIdBalance;

                TogglePaymentButtonVisiblity();

                ToggleAutoPayOptionVisibility();

                // now update the actual payment amount
                GetSelectedPaymentOptionAmount();
            }

            var GetSelectedPaymentOptionAmount = function () {

                const isChipAwaySelected = $("input[type=radio][name=PaymentOption]:checked").val() == "chipaway";
                const chipAwayPaymentAmount = $("#CurrentInvitee_ChipAwayPaymentAmount").val();

                if (isChipAwaySelected) {
                    if (chipAwayPaymentAmount == "" || chipAwayPaymentAmount < YouLi.Trip.Payments.ChipAwayMinimumAmount) {

                        $("#ChipAwayErrorMessage").text(`Payment cannot be less than ${YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.Trip.Payments.ChipAwayMinimumAmount)}`).removeClass("hidden");
                        return;
                    }
                    else if (chipAwayPaymentAmount > YouLi.Trip.Payments.ChipAwayMaximumAmount) {

                        $("#ChipAwayErrorMessage").text(`Payment cannot be greater than the amount you owe, ${YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.Trip.Payments.ChipAwayMaximumAmount)}`).removeClass("hidden");
                        return;
                    }
                }

                YouLi.Common.UI.ShowLoading();

                var previewMode = $("#PreviewMode").val();
                let data = {
                    preview: previewMode,
                    costInstallmentId: isChipAwaySelected ? '' : YouLi.Trip.Payments.SelectedInstallmentId,
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    couponCode: $("#ChargeCouponCode").val(),
                    isChipAway: isChipAwaySelected,
                    chipAwayPaymentAmount: chipAwayPaymentAmount
                }

                if (previewMode.toLowerCase() == "true") {
                    data.selectedTripPackageId = $("#SelectedPackageId").val();
                }

                $.ajax({
                    url: `/trip/getinstallmentamount`,
                    type: "POST",
                    dataType: "json",
                    data: JSON.stringify(data),
                    contentType: "application/json; charset=utf-8",
                    complete: function (response) {
                        YouLi.Common.UI.HideLoading();
                        if (response.responseJSON != undefined && response.responseJSON.url) {
                            window.location.href = response.responseJSON.url;
                        }
                        else if (response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                            YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                        }
                        else if (response.responseJSON.cookieError && response.responseJSON.message) {
                            YouLi.Common.UI.ShowStaticStandardDialogNoClose(response.responseJSON.message, "Identity error");
                        }
                        else {
                            YouLi.PaymentChargeForm.AmountDue = response.responseJSON.installmentAmountDue; // + response.responseJSON.upfrontPaymentAmount;

                            if (!isChipAwaySelected) {
                                if (response.responseJSON.installmentIsBalance)
                                    $(".amount-due-balance").html(YouLi.Common.Currency.DisplayCost(YouLi.PaymentChargeForm.Currency, YouLi.PaymentChargeForm.AmountDue));
                                else
                                    $(".amount-due-installment").html(YouLi.Common.Currency.DisplayCost(YouLi.PaymentChargeForm.Currency, YouLi.PaymentChargeForm.AmountDue));
                            }

                            UpdateChargeDetails(response.responseJSON.chargeLabel);

                            $("input[Name=ChargeInstallmentId]").val(YouLi.Trip.Payments.SelectedInstallmentId);
                        }
                    }
                });
            };

            var ChangeMethod = function (selectedMethod, preventScroll, scrollToPaymentLine) {

                var selectedPaymentMethodElement = $('input[type=radio][name=PaymentMethod]:checked');

                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();

                // If the user initiated this change, scroll to the top of the Payment Methods selection if it is being shown, otherwise scroll to the top of the payments table (YOULI-3747)
                if (selectedPaymentOption && !preventScroll) {
                    var scrollTarget = $("#ChoosePaymentMethodTitle").length > 0 && scrollToPaymentLine ? $("#ChoosePaymentMethodTitle") : $(".content-trip-package-container");
                    $('html, body').animate({
                        scrollTop: scrollTarget.offset().top - 80
                    }, 1000);
                }

                // hide all and then show whichever is needed
                $(".credit-card-surcharge-val").addClass("hidden");
                $(".refund-protect-val").addClass("hidden");
                $("#RefundProtectSelection").addClass("hidden");
                $(".payment-method-details").addClass("hidden");

                $("#PhoneDetails").addClass("hidden");
                $("#SavedPaymentMethodAutoPayDetails").addClass("hidden");
                $("#ThirdPartyCardDetails").addClass("hidden");
                $("#BankTransferDetails").addClass("hidden");




                // standard labels
                let isPackageSoldout = $(".pay-now-button-label").data('sold-out');
                let isFull = $(".pay-now-button-label").data('already-full');
                let wouldOverbook = $(".pay-now-button-label").data('would-overbook');

                if (isFull) {
                    $(".pay-now-button-label").text('Sold Out');
                } else if (wouldOverbook) {
                    $(".pay-now-button-label").text('Update Occupancy or Package');
                }
                else if (isPackageSoldout) {
                    $(".pay-now-button-label").text("Sold Out");
                } else {
                    $(".pay-now-button-label").text(YouLi.Trip.Payments.PayNowButtonText);
                }

                // if the tab is currently being displayed, update the footer for the selected method
                var tabIsSelected = !$("#content-trip-paymentdetails").hasClass("hidden");
                if (tabIsSelected && selectedMethod)
                    SetFooterToPaymentButton(selectedMethod);

                switch (selectedMethod) {
                    case "savedpaymentmethod":
                        if (selectedPaymentOption && YouLi.Trip.HasAchSurcharge === false) {
                            if (YouLi.Payments.Default.SurchargePercent > 0) {
                                // show the surcharge value associated with this selected payement method
                                selectedPaymentMethodElement.closest(".row").find(".credit-card-surcharge-val").removeClass("hidden");
                            }
                        }
                        break;
                    case "thirdpartycard":
                        if (selectedPaymentOption) {
                            if (YouLi.Trip.Payments.ThirdPartyCardSurchargePercent > 0) {
                                $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                                // show the surcharge value associated with this selected payement method
                                selectedPaymentMethodElement.closest(".row").find(".credit-card-surcharge-val").removeClass("hidden");
                            }
                        }
                        $("#ThirdPartyCardDetails").removeClass("hidden");
                        break;
                    case "banktransfer":
                        $("#PayBankTransfer").removeClass("hidden");
                        $("#BankTransferDetails").removeClass("hidden");
                        // override some labels
                        if (isFull) {
                            $(".pay-now-button-label").text('Sold Out');
                        } else if (wouldOverbook) {
                            $(".pay-now-button-label").text('Update Occupancy or Package');
                        }
                        else if (isPackageSoldout) {
                            $(".pay-now-button-label").text("Sold Out");
                        } else {
                            $(".pay-now-button-label").text(YouLi.Trip.Payments.NotifyPlannerButtonText);
                        }
                        break;
                    case "creditcard":
                        $("#PayCreditCard").removeClass("hidden");

                        if (selectedPaymentOption && YouLi.Trip.HasAchSurcharge === false) {
                            if (YouLi.PaymentChargeForm.Default.SurchargePercent > 0) {
                                // show the surcharge value associated with this selected payement method
                                selectedPaymentMethodElement.closest(".row").find(".credit-card-surcharge-val").removeClass("hidden");
                            }
                        }
                        break;
                    case "paypallink":
                        $("#PayPayPalLink").removeClass("hidden");
                        break;
                    case "phone":
                        $("#PayPhone").removeClass("hidden");
                        $("#PhoneDetails").removeClass("hidden");
                        if (isFull) {
                            $(".pay-now-button-label").text('Sold Out');
                        } else if (wouldOverbook) {
                            $(".pay-now-button-label").text('Update Occupancy or Package');
                        }
                        else if (isPackageSoldout) {
                            $(".pay-now-button-label").text('Sold Out');
                        } else {
                            var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
                            $(".pay-now-button-label").text(isMobile ? YouLi.Trip.Payments.PayNowButtonText : YouLi.Trip.Payments.NotifyPlannerButtonText);
                        }

                        break;
                    case "customlink":
                        $("#PayCustomLink").removeClass("hidden");
                        break;
                }

                ToggleRefundProtectVisiblity();

                TogglePaymentButtonVisiblity();

                ToggleAutoPayOptionVisibility();

                // update the charge details if they have selected a method - we have to redo this here because of method-based surcharges
                if (selectedMethod)
                    UpdateChargeDetails(undefined);
            };

            var ToggleRefundProtectVisiblity = function () {
                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                if (selectedPaymentMethod) {
                    if (selectedPaymentOption) {
                        $(".refund-protect-val").removeClass("hidden");
                    }

                    if (YouLi.Trip.Payments.RefundProtectPercent > 0) {
                        $("#RefundProtectSelection").removeClass("hidden");
                    }
                }

            }

            var TogglePaymentButtonVisiblity = function () {
                const selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                const selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                const isChipAwaySelected = $("input[type=radio][name=PaymentOption]:checked").val() == "chipaway";
                const chipAwayPaymentAmount = $("#CurrentInvitee_ChipAwayPaymentAmount").val();
                const validChipAwayAmountEntered = !isChipAwaySelected || (chipAwayPaymentAmount >= YouLi.Trip.Payments.ChipAwayMinimumAmount && chipAwayPaymentAmount <= YouLi.Trip.Payments.ChipAwayMaximumAmount);

                // Only show if a method AND the payment option have both been selected, and chip away amount is valid if that is the selected payment optoin
                const showPaymentButtons = !(selectedPaymentMethod && selectedPaymentOption && validChipAwayAmountEntered);
                $(".payment-button").toggleClass("hidden", showPaymentButtons);

                $(".enrol-in-autopay").toggleClass("hidden", showPaymentButtons);
            };

            var ToggleAutoPayOptionVisibility = function () {
                const selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                const selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                const showSavedPaymentMethodAutoPayDetails = selectedPaymentMethod == "savedpaymentmethod"
                    && selectedPaymentOption
                    && (YouLi.Trip.Payments.HasAnyOwingInstallments && YouLi.Trip.Payments.SelectedInstallmentId !== YouLi.Trip.Payments.InstallmentIdBalance);
                $("#SavedPaymentMethodAutoPayDetails").toggleClass("hidden", !showSavedPaymentMethodAutoPayDetails);

                // show the "promo" for AutoPay under credit card when no installment has been seleted at all, or when the balance has not been selected
                const showCreditCardAutoPayDetails = !selectedPaymentOption
                    || (YouLi.Trip.Payments.HasAnyOwingInstallments && YouLi.Trip.Payments.SelectedInstallmentId !== YouLi.Trip.Payments.InstallmentIdBalance);
                $("#CreditCardAutoPayDetails").toggleClass("hidden", !showCreditCardAutoPayDetails);
            };

            var UpdateBillToEmail = function () {

                let billToEmail = $("input[Name=billtoemail]");

                if (billToEmail.length > 0) {
                    billToEmail.val(YouLi.Trip.Payments.BillToEmail);
                    billToEmail.prop("readOnly", billToEmail.val().length > 0)
                }
            }

            var UpdateChargeDetails = function (label) {

                /// Add surcharge and any other charges to the amount before setting
                let selectedPaymentOption = $("input[type=radio][name=PaymentOption]:checked").val();
                let selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();
                let surchargeAmount = 0;
                let totalAmountDue = 0;

                if (selectedPaymentMethod === "thirdpartycard") {
                    surchargeAmount = parseFloat((YouLi.PaymentChargeForm.AmountDue * YouLi.Trip.Payments.ThirdPartyCardSurchargePercent / 100).toFixed(2));
                    $(".credit-card-surcharge-val").html(`+${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);

                    if (selectedPaymentOption && YouLi.Trip.Payments.ThirdPartyCardSurchargePercent > 0) {
                        $(".cost-line-item-credit-card-surcharge").removeClass("hidden");
                        $(".cost-line-item-surcharge-val").removeClass("hidden");
                    }
                }
                else if (selectedPaymentMethod === "savedpaymentmethod" || selectedPaymentMethod === "creditcard") {
                    const paymentMethod = selectedPaymentMethod === "savedpaymentmethod" ? YouLi.Trip.Payments.SaveCardMethodType : null;
                    surchargeAmount = YouLi.PaymentChargeForm.GetSurchargeAmount(paymentMethod);

                    $(".credit-card-surcharge-val").html(`+${YouLi.PaymentChargeForm.GetFormattedCurrency(surchargeAmount)}`);
                    if (selectedPaymentOption
                        && YouLi.PaymentChargeForm.Default.SurchargePercent > 0
                        && YouLi.PaymentChargeForm.Ach.HasSurcharge === false) {

                        // show the surcharge for the selected payment method
                        let selectedPaymentMethodElement = $('input[type=radio][name=PaymentMethod]:checked');
                        selectedPaymentMethodElement.closest(".row").find(".credit-card-surcharge-val").removeClass("hidden");
                    }
                }

                totalAmountDue = YouLi.PaymentChargeForm.AmountDue + surchargeAmount;

                // add Refund Protect (if applicable and selected)
                $(".refund-protect-val").addClass("hidden");
                let refundProtectAmount = 0;
                let refundProtectPercentage = 0;
                if (YouLi.Trip.Payments.RefundProtectPercent > 0
                    && selectedPaymentOption
                    && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']:checked").val() != undefined
                    && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']:checked").val().toLowerCase() == "optedin"
                ) {

                    refundProtectAmount = parseFloat((totalAmountDue * YouLi.Trip.Payments.RefundProtectPercent / 100).toFixed(2));
                    refundProtectPercentage = YouLi.Trip.Payments.RefundProtectPercent;
                    $(".refund-protect-val").html(`+${YouLi.PaymentChargeForm.GetFormattedCurrency(refundProtectAmount)}`);

                    $(".refund-protect-val").removeClass("hidden");
                }
                else {
                    $(".refund-protect-val").addClass("hidden");
                }

                YouLi.PaymentChargeForm.UpdatePaymentInfo({
                    surchargeAmount: surchargeAmount,
                    refundProtectAmount: refundProtectAmount,
                    refundProtectPercent: refundProtectPercentage
                });

                if ((selectedPaymentMethod === "creditcard" || selectedPaymentMethod == "savedpaymentmethod") && YouLi.PaymentChargeForm.Ach.HasSurcharge === true) {
                    $(".cost-line-item-amount-payment-total").html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmountNoSurcharge()));
                    $('#GenericPaymentFormDialog')
                        .find('.cost-line-item-amount-payment-total')
                        .html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));
                } else {
                    $(".cost-line-item-amount-payment-total").html(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));
                }

                $("input[Name=RefundProtectAmount]").val(refundProtectAmount);
                $("input[Name=ChargeAmount]").val(YouLi.PaymentChargeForm.GetChargeAmount());
                $("input[Name=SurchargeAmount]").val(surchargeAmount);

                if (label) {
                    $("input[Name=ChargeLabel]").val(label);
                }

                // trigger the change event on the ChargeAmount field for things like updating the payment intent for Stripe
                $("input[Name=ChargeAmount]").trigger("change");
            };

            var RefreshInviteesTab = function (tabHTML, showInviteeTab) {
                if (showInviteeTab) {
                    // Display and refresh invitees tab (if not already displayed)
                    $(".content-tab-invitees").removeClass("hidden");

                    $("#invitees-content").html(tabHTML);

                    YouLi.Trip.SetupInviteeSectionMenu();
                }
            }

            var continuePayment = function () {

                UpdateBillToEmail();
                UpdateChargeDetails(undefined);
                var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();

                switch (selectedPaymentMethod) {

                    case "savedpaymentmethod":
                        const totalAmount = YouLi.PaymentChargeForm.GetChargeAmount();
                        $("#SavedPaymentMethodConfirmationDialog .current-payment-amount").text(YouLi.PaymentChargeForm.GetFormattedCurrency(totalAmount));
                        $('#ChargeAmount').val(totalAmount);

                        $("#AutoPayEnrolOption").toggleClass("hidden", YouLi.Trip.Payments.SelectedInstallmentId == YouLi.Trip.Payments.InstallmentIdBalance);

                        $("#EnrolInAutoPay").prop("checked", YouLi.Trip.Payments.RecentlyClickedEnrolAutoPay);
                        YouLi.Trip.Payments.RecentlyClickedEnrolAutoPay = false; // reset for next time

                        $("#SavedPaymentMethodConfirmationDialog").modal("show");

                        break;

                    case "thirdpartycard":

                        if (!$("#PaymentCostChargingDetailsForm").valid())
                            return;

                        $("#SavedThirdPartyCardConfirmationDialog .current-payment-amount").text(
                            YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));

                        $("#SavedThirdPartyCardConfirmationDialog").modal("show");

                        break;

                    case "creditcard":
                        YouLi.Common.UI.ShowLoading();

                        //google tag manager
                        if ($("#IsBooked").val() == "" || $("#IsBooked").val() == "False") {
                            var gaData = YouLi.Common.GetGAData("begin_checkout");
                            dataLayer.push({ ecommerce: null });
                            dataLayer.push(gaData);
                        }

                        // log analytics - don't do anything on success/fail
                        $.ajax({
                            url: `/trip/logpaymentclick?tripId=${$("#TripId").val()}&inviteeId=${$("#InviteeId").val()}`,
                            type: 'POST',
                            cache: false,
                            contentType: false,
                            processData: false,
                            complete: function (response) {
                                if (response.responseJSON.cookieError && response.responseJSON.message) {
                                    YouLi.Common.UI.HideLoading();
                                    YouLi.Common.UI.ShowStaticStandardDialogNoClose(response.responseJSON.message, "Identity error");
                                }
                            }

                        });

                        if (YouLi.Trip.Payments.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.Stripe) {
                            YouLi.CreditCardPaymentForm.InitialiseStripe()
                                .then(() => {
                                    YouLi.Common.UI.HideLoading();

                                    $("#GenericPaymentFormDialog").modal("show");
                                })
                        }
                        else {
                            YouLi.Common.UI.HideLoading();

                            $("#GenericPaymentFormDialog").modal("show");
                        }

                        break;
                    case "banktransfer":
                    case "paypallink":
                    case "phone":
                    case "customlink":
                        YouLi.Trip.Payments.CheckForOverpayment()
                            .then(() => processPayment(selectedPaymentMethod));

                        break;
                }

            };

            YouLi.Trip.Payments.InitialiseUI = function () {
                YouLi.Trip.Payments.InitialiseResponseChecks();
                YouLi.Common.UI.Init();
            };

            YouLi.Trip.Payments.UpdateTripPackage = function (selectedPackageId, selectedTripPackageRoomId) {

                const defaultPromise = new Promise((resolve, reject) => {
                    resolve('Success!');
                });

                let programTabIsHidden = $("#content-trip-program").hasClass("hidden");
                let itineraryTabIsHidden = $("#content-trip-itinerary").length == 0 || $("#content-trip-itinerary").hasClass("hidden");
                let taskTabIsHidden = $("#content-trip-tasks").length == 0 || $("#content-trip-tasks").hasClass("hidden");
                let selectedMenuSection = $(".content-trip-details-menu .nav li.active").data("section");

                var previewMode = $("#PreviewMode").val();
                if (selectedPackageId) {
                    YouLi.Common.UI.ShowLoading();
                    var tripId = $("#TripId").val();
                    var inviteeId = $("#InviteeId").val();

                    return $.ajax({
                        url: `/trip/UpdateInviteeTripPackage/?packageId=${selectedPackageId}&packageRoomId=${selectedTripPackageRoomId}&tripId=${tripId}&inviteeId=${inviteeId}&preview=${previewMode}`,
                        type: "GET",
                        dataType: "json",
                        contentType: "application/json; charset=utf-8",
                        complete: function (response) {

                            YouLi.Common.UI.HideLoading();

                            if (response.responseJSON != undefined && response.responseJSON.url) {
                                window.location.href = response.responseJSON.url;
                            }
                            else if (response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                                YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                            }
                            else {

                                if (response.responseJSON.showCosts) {
                                    $(".content-tab-paymentdetails").removeClass("hidden");
                                }

                                var initialSelectedPaymentMethod = $("input[type=radio][name=PaymentMethod]:checked").val();
                                if ($(".content-trip-paymentdetails-costs").length > 0)
                                    $(".content-trip-paymentdetails-costs").html(response.responseJSON.paymentDetailsHtml);

                                $(".package-card").html(response.responseJSON.packageCardHtml);
                                $(".content-trip-heading-details-cost").html(response.responseJSON.tripCostSummaryHtml);

                                // Update payment info - but only if the server has passed it back
                                if ($(".content-trip-paymentdetails-payment-info").length > 0 && response.responseJSON.paymentInfoHtml.length > 0)
                                    $(".content-trip-paymentdetails-payment-info").html(response.responseJSON.paymentInfoHtml);

                                YouLi.Trip.UpdateProgramContent(programTabIsHidden, response.responseJSON.contentProgramHtml);
                                YouLi.Trip.UpdateItineraryContent(itineraryTabIsHidden, response.responseJSON.contentItineraryHtml);
                                YouLi.Trip.UpdateTaskContent(taskTabIsHidden, response.responseJSON.contentTaskHtml);
                                YouLi.Trip.UpdateMenuContent(selectedMenuSection, response.responseJSON.menuHtml);

                                YouLi.Trip.Schedule.Response.InitialiseResponseChecks();

                                //google analytics
                                var preveiousSelectedTripPackage = $("#GA_PackageName").val();

                                PushRemoveCartGAData();
                                $("#GoogleAnalyticsData").html(response.responseJSON.googleAnalyticsHtml);
                                PushAddCartGAData();

                                YouLi.Trip.Payments.InitialiseUI();
                                YouLi.Common.UI.Init();

                                // reinitialise
                                $("input[type=radio][name=PaymentMethod][value=" + initialSelectedPaymentMethod + "]").attr("checked", true);
                                ChangeMethod(initialSelectedPaymentMethod, true);

                                // YOULI-5433 turning off this footer button refresh here, as we don't actually see any need to refresh the footer now.  It's already
                                // refreshed above based on the selected payment method.
                                //if (!$("input[type=radio][name=PaymentMethod]:checked").val()) {
                                //    // Have to force footer update after package selection changes even if any payment method hasn't been selected
                                //    SetFooterToPaymentButton(true);
                                //}
                            }
                        }

                    });
                }

                return defaultPromise;

            }

            YouLi.Trip.Payments.CancelAutoPay = function () {

                YouLi.Common.UI.ShowLoading();

                const url = "/Trip/CancelAutoPayEnrollment";
                const data = {
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val()
                };

                YouLi.Common.Post(
                    url,
                    data,
                    (response) => {
                        YouLi.Common.UI.HideLoading();

                        if (!response.success) {
                            YouLi.Common.UI.ShowStandardDialog("An error occurred when cancelling AutoPay. Try again or contact your planner.");
                        }
                        else {
                            $(".content-trip-paymentdetails-costs").html(response.contentCostPaymentDetailsHtml);
                            YouLi.Trip.Payments.RefreshPaymentMethod(true);
                        }
                    },
                    () => {
                        YouLi.Common.UI.HideLoading();
                        YouLi.Common.UI.ShowStandardDialog("An error occurred when cancelling AutoPay. Try again or contact your planner.");
                    }
                );
            };

            var PushRemoveCartGAData = function () {
                //remove_from_cart event
                var removeFromCartData = YouLi.Common.GetGAData("remove_from_cart");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(removeFromCartData);
            }

            var PushAddCartGAData = function () {
                //add_to_cart
                var removeFromCartData = YouLi.Common.GetGAData("add_to_cart");
                dataLayer.push({ ecommerce: null });
                dataLayer.push(removeFromCartData);
            }

            InitialisePayments = function () {

                // If credit card is the only payment method, initialise to select that.  Otherwise leave it unselected so the user
                // has to review details before seeing the "notify" button
                if ($("input[name=PaymentMethod]:not(':disabled')").length == 1) {
                    if ($("input[name=PaymentMethod]:not(':disabled')").val() === "creditcard") {
                        $("input[name=PaymentMethod]:not(':disabled')").attr("checked", true);
                    }
                }

                // If remaining balance is the only payment option, initialise to select that.
                if ($("input[name=PaymentOption]:not(':disabled')").length == 1) {
                    if ($("input[name=PaymentOption]:not(':disabled')").val() === "balance") {
                        $("input[name=PaymentOption]:not(':disabled')").attr("checked", true);
                    }
                }

                $(document).on("change", "input[type=radio][name=PaymentOption]", function () {
                    var selectedOption = $(this).val();

                    ChangePaymentOption(selectedOption);
                });
                //ChangePaymentOption($("input[type=radio][name=PaymentOption]:checked").val());        // YOULI-8514 remove initial server call

                $(document).on("change", "input[type=radio][name=PaymentMethod]", function () {
                    var selectedMethod = $(this).val();

                    ChangeMethod(selectedMethod, false, true);

                });
                ChangeMethod($("input[type=radio][name=PaymentMethod]:checked").val(), true);

                $(document).on("change", "input[type=radio][name='CurrentInvitee.RefundProtectSelection']", function () {

                    // trigger change method, but it will just be for updating refund protect
                    var selectedPaymentMethod = $('input[type=radio][name=PaymentMethod]:checked').val();
                    ChangeMethod(selectedPaymentMethod, true, true); // Nb: no scroll when changing Refund Protect

                });
                ChangeMethod($("input[type=radio][name=PaymentMethod]:checked").val(), true);


                $(document).on("click", ".apply-coupon-code", function () {

                    if ($("#PreviewMode").val().toLowerCase() == "true")
                        return;

                    $(".content-trip-coupon-code-error").addClass("hidden");
                    YouLi.Common.UI.ShowLoading();

                    let selectedCouponCode = $("#SelectedCouponCode").val();

                    const data = {
                        couponCode: selectedCouponCode,
                        tripId: $("#TripId").val(),
                        inviteeId: $("#InviteeId").val(),
                        installmentId: YouLi.Trip.Payments.SelectedInstallmentId
                    };

                    $.ajax({
                        url: `/trip/applycouponcode/`,
                        type: "POST",
                        dataType: "json",
                        data: JSON.stringify(data),
                        contentType: "application/json; charset=utf-8",
                        complete: function (response) {
                            YouLi.Common.UI.HideLoading();
                            if (response.responseJSON != undefined && response.responseJSON.url) {
                                window.location.href = response.responseJSON.url;
                            }
                            else if (response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                                YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                            }
                            else if (response.responseJSON.errorMessage) {
                                $(".content-trip-coupon-code-error").removeClass("hidden")
                                $("#CouponCodeErrorMessage").text(response.responseJSON.errorMessage);
                            }
                            else if (response.responseJSON.cookieError && response.responseJSON.message) {
                                YouLi.Common.UI.ShowStaticStandardDialogNoClose(response.responseJSON.message, "Identity error");
                            }
                            else {

                                //google tag manager
                                if ($("#IsBooked").val() == "" || $("#IsBooked").val() == "False") {
                                    var gaData = YouLi.Common.GetGAData("select_promotion");
                                    dataLayer.push({ ecommerce: null });
                                    dataLayer.push(gaData);
                                }

                                $("#SelectedCouponCode").val("");
                                $("#BreakdownTable").html(response.responseJSON.newPaymentsBreakdownTable);
                                $(".content-trip-heading-details-cost").html(response.responseJSON.newCostSummaryHtml);
                                if ($(".cost-installments-selection:not(.individual)").length > 0) {
                                    $(".cost-installments-selection:not(.individual)").html(response.responseJSON.newInstallmentsTableHtml);
                                }
                                YouLi.Trip.Payments.InitialiseUI();
                                $("input[Name=ChargeCouponCode]").val(selectedCouponCode);

                                // if balance is being paid, update the current amount due. For all other installments, we do NOT reduce the amount based on the coupon code.
                                if (response.responseJSON.isBalance) {
                                    YouLi.PaymentChargeForm.AmountDue = response.responseJSON.balanceAmount;
                                }
                                UpdateChargeDetails(undefined);

                                $(".amount-due-balance").html(YouLi.PaymentChargeForm.GetFormattedCurrency(response.responseJSON.balanceAmount));
                            }
                        }

                    });
                });
            };

            $(function () {

                YouLi.Trip.Payments.InitialiseUI();

                $(document).on("click", ".pay-now-button", function () {

                    YouLi.Trip.Payments.RecentlyClickedEnrolAutoPay = $(this).hasClass("enrol-in-autopay");    // store for later use

                    if ($("#RecentPaymentMadeDialog").length == 1) {
                        $("#RecentPaymentMadeDialog .current-payment-amount").text(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetChargeAmount()));
                        $("#RecentPaymentMadeDialog").modal("show");
                        return;
                    }

                    YouLi.Trip.Payments.RefundProtectOptedOutConfirmed = false;

                    if ($("#RefundProtectConfirmationDialog").length > 0 && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']").length > 0 && $("input[type=radio][name='CurrentInvitee.RefundProtectSelection']:checked").val().toLowerCase() == "optedout") {
                        $("#RefundProtectConfirmationDialog").modal("show");
                        return;
                    }

                    continuePayment();
                });

                $(document).on("click", "#RecentPaymentConfirmationFormOk", function () {

                    $("#RecentPaymentMadeDialog").modal("hide");

                    continuePayment();
                });

                $(document).on("click", "#RefundProtectConfirmationFormOk", function () {

                    if (!$("#RefundProtectConfirmationForm").valid())
                        return;

                    $("#RefundProtectConfirmationDialog").modal("hide");

                    YouLi.Trip.Payments.RefundProtectOptedOutConfirmed = true;

                    continuePayment();
                });

                $(document).off("click", "#SavedPaymentMethodConfirmationOk");
                $(document).on("click", "#SavedPaymentMethodConfirmationOk", function () {

                    $("#SavedPaymentMethodConfirmationDialog").modal("hide");

                    YouLi.Trip.Payments.processPaymentWithSavedPaymentMethod(false);
                });

                $(document).off("click", "#SavedThirdPartyCardConfirmationOk");
                $(document).on("click", "#SavedThirdPartyCardConfirmationOk", function () {

                    $("#SavedThirdPartyCardConfirmationDialog").modal("hide");

                    YouLi.Trip.Payments.processPaymentWithSavedPaymentMethod(true);
                });

                $(document).on('click', '.save-card-login a', function (e) {
                    e.preventDefault();
                    const persona = 'traveler';
                    const redirectUrl = $(this).attr('href');

                    window.location.href = `${redirectUrl}?defaultPersona=${persona}`;
                })

                if (YouLi.Trip.Payments.InviteeHasOwing) {
                    // showing payment details and form
                    InitialisePayments();
                }

                $(document).on("change", "#SelectedPackageId", function () {
                    YouLi.Trip.Payments.UpdateTripPackage($(this).val());
                });

                $(document).on('input', '#CurrentInvitee_ChipAwayPaymentAmount', function () {
                    $(this).val($(this).val().replace(/[^\d.]/g, ''));
                });

                $(document).on('blur', '#CurrentInvitee_ChipAwayPaymentAmount', function () {
                    $("#ChipAwayErrorMessage").addClass("hidden");
                    GetSelectedPaymentOptionAmount();   // update the amount to be charged
                    TogglePaymentButtonVisiblity();
                });

                $(document).on("click", "#ChangeAutoPayPaymentMethod", function () {
                    $("#ChangeAutoPayConfirmationDialog").modal("show");
                });
                $(document).on("click", "#CancelAutoPay", function () {
                    $("#CancelAutoPayConfirmationDialog").modal("show");
                });

                $(document).on("click", ".cancel-autopay-button", function () {

                    $("#ChangeAutoPayConfirmationDialog").modal("hide");
                    $("#CancelAutoPayConfirmationDialog").modal("hide");

                    YouLi.Trip.Payments.CancelAutoPay();
                });

                // If credit card payemnt form is loaded (it won't be initially for $0 packages)
                if (YouLi.CreditCardPaymentForm) {
                    var selectedOption = $('input[type=radio][name=PaymentOption]:checked').val();
                    YouLi.CreditCardPaymentForm.UpdateAutoPayVisibility(selectedOption != "balance");
                }


                // Trim fields that we do not want to allow spaces in
                $(".trim-before-validation").on("blur", function () {
                    $(this).val($(this).val().trim());
                });
            });

        }(YouLi.Trip.Payments ? YouLi.Trip.Payments : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));